/* sb-dc-nostart.js — don't show the "What are you making?" popup on the way in.

   Customers arrive from a product page, so the popup has already been answered
   by the time they get here. We answer it for them and press Start behind a
   cover, so they land straight on the canvas.

   Which product it answers with, in order:
     1. ?product=<handle> is one the popup lists          -> that card
     2. the handle reads as something we carry            -> that card, and the
        (see sb-dc-handle.js)                                size from the
                                                             handle, e.g.
                                                             8x8-step-and-repeat-
                                                             banner-with-stand
                                                             -> Custom Step &
                                                             Repeat, 8' x 8'
     3. neither                                          -> whatever is selected
                                                             once we open that
                                                             category

   2026-08-31: this now owns the ?blank=1 route too, and sb-dc-blank.js has
   been dropped from the layout. blank.js only knew the 15 handles in __CAT, so
   the "Create Your Design Online" button on a packaged product page —
   8x8-step-and-repeat-banner-with-stand and the dozens like it — left the
   popup sitting open on Custom Vinyl Banner 8' x 4'. Step 2 above is exactly
   what that route was missing, so one owner is better than two.

   ⚠ Route 2 covers the packaged handles - "with stand", "with stand and red
   carpet". The design center has no stand or carpet to price, so it opens the
   BANNER-ONLY product and the cart line will be the banner. The artwork and
   the size are right; the hardware is not on the line. If that turns into
   wrong orders, the fix is upstream: give those products their own catalog
   entries in the bundle, or send the customer to the banner-only page.

   The cover comes off as soon as we are done, because the same popup is what
   "Change product / finishing" opens later, and that one must be visible.

   Order note: with ?tpl= present, sb-dc-tplfix.js builds the template once the
   popup is gone, against whatever spec we settled on here. */
(function () {
  "use strict";

  var qs = location.search;
  var pm = /[?&]product=([^&]+)/.exec(qs);
  var HANDLE = pm ? decodeURIComponent(pm[1]) : "";

  var state = { covered: false, cat: false, picked: false, sized: false,
                started: false, via: "", size: null, gaveUp: "" };
  window.__dcNoStartDebug = function () { return JSON.parse(JSON.stringify(state)); };

  /* ---- cover ----------------------------------------------------------- */

  // opacity, not display:none - the buttons need a real box for a click to land.
  var COVER_ID = "sbdc-nostart-cover";
  function cover() {
    if (document.getElementById(COVER_ID)) return;
    var s = document.createElement("style");
    s.id = COVER_ID;
    s.textContent = "#sbdc-start{opacity:0!important;pointer-events:none!important}";
    (document.head || document.documentElement).appendChild(s);
    state.covered = true;
  }
  function uncover() {
    var s = document.getElementById(COVER_ID);
    if (s && s.parentNode) s.parentNode.removeChild(s);
    state.covered = false;
  }
  cover();

  /* ---- popup ----------------------------------------------------------- */

  function popup() {
    var el = document.getElementById("sbdc-start");
    return el && el.getClientRects && el.getClientRects().length ? el : null;
  }

  /* 2026-09-16: one handle, two cards. X-banner, Double Sided X-Banner and
     Pop up Retractable each publish a "(Banner Only)" card and a "+ Stand"
     card under ONE handle (the second carries key: xb-stand / dxb-stand /
     retract-stand). This returned whichever came first in __CAT, which is
     always the Banner Only one, so the product page - whose own default
     variant is Banner + Stand - handed the customer a cheaper banner-only
     line the moment they pressed "Create Your Design Online". Reported
     2026-09-16 (X-banner $35 instead of $80).

     The stand card now wins, which is the variant those product pages open
     on. A customer who wants the banner on its own changes it inside the
     design center - "Change product / finishing" lists both cards and the
     price follows. A handle with a single card is unaffected, and
     hardware-free products (stickers, decals, flags) carry no `pick` at all,
     so they take the first-match path exactly as before. */
  function isStandCard(it) {
    var pick = (it && it.pick) || [];
    for (var k = 0; k < pick.length; k++) {
      if (String(pick[k]).toLowerCase().indexOf("stand") >= 0) return true;
    }
    return false;
  }

  function catalogEntry(handle) {
    var cat = window.__CAT;
    if (!cat || !handle) return null;
    var first = null;
    for (var i = 0; i < cat.length; i++) {
      var items = (cat[i] && cat[i].items) || [];
      for (var j = 0; j < items.length; j++) {
        var it = items[j];
        if (!it || it.handle !== handle) continue;
        if (isStandCard(it)) return { item: it, cat: i };
        if (!first) first = { item: it, cat: i };
      }
    }
    return first;
  }

  // Direct hit first, then whatever the handle reads as.
  var resolved = null;
  function resolve() {
    if (resolved || !window.__CAT || !HANDLE) return resolved;
    var e = catalogEntry(HANDLE);
    if (e) { state.via = "listed"; resolved = e; return resolved; }

    var p = window.__dcHandle && window.__dcHandle(HANDLE);
    if (p && p.dcHandle) {
      e = catalogEntry(p.dcHandle);
      if (e) {
        state.via = "read:" + p.dcHandle;
        if (p.w && p.h) state.size = { w: p.w, h: p.h };
        resolved = e;
        return resolved;
      }
    }
    return null;
  }

  function cardFor(pop, e) {
    var label = (e.item.nameKo || e.item.name || "").trim();
    var i;

    // 2026-09-15: handle first - Pop-Up 8x8 and 10x8 now share one display name
    var byHandle = pop.querySelectorAll('.sbdc-prod[data-handle="' + e.item.handle + '"]');
    if (byHandle.length === 1) return byHandle[0];
    /* 2026-09-16: ...but a handle can carry TWO cards - see catalogEntry above
       - and then the handle alone cannot say which. The label decides, and
       falls back to the first so this never returns less than it used to. */
    if (byHandle.length > 1) {
      if (label) {
        for (i = 0; i < byHandle.length; i++) {
          if ((byHandle[i].textContent || "").trim().indexOf(label) === 0) return byHandle[i];
        }
      }
      return byHandle[0];
    }

    if (!label) return null;
    var cards = pop.querySelectorAll(".sbdc-prod");
    for (i = 0; i < cards.length; i++) {
      if ((cards[i].textContent || "").trim().indexOf(label) === 0) return cards[i];
    }
    return null;
  }

  // The size boxes are React-controlled, so a plain .value assignment is
  // overwritten on the next render - the native setter plus an input event is
  // what React listens for.
  function setField(el, v) {
    var d = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value");
    if (d && d.set) d.set.call(el, String(v)); else el.value = String(v);
    el.dispatchEvent(new Event("input", { bubbles: true }));
  }

  // Only for free-size products: a fixed-size product ignores this anyway and
  // its size came with the card.
  function applySize(pop, e) {
    if (!state.size || e.item.unit !== "ft" || e.item.fixedOnly) return true;
    var ins = pop.querySelectorAll("input");
    if (ins.length < 2) return false;
    if (+ins[0].value !== state.size.w) setField(ins[0], state.size.w);
    if (+ins[1].value !== state.size.h) setField(ins[1], state.size.h);
    return true;
  }

  /* ---- driver ---------------------------------------------------------- */

  var ticks = 0, since = 0;
  var timer = setInterval(function () {
    // Safety net: never leave the popup invisible-but-there.
    if (++ticks > 160) { state.gaveUp = "timeout"; uncover(); clearInterval(timer); return; }

    var pop = popup();
    if (!pop) return;                                  // not rendered yet

    if (HANDLE && !state.picked) {
      var e = resolve();
      if (!e) {
        if (!window.__CAT) return;                     // catalog not up yet
        state.gaveUp = "unknown-product:" + HANDLE;
        state.picked = true;                           // start on the default
        return;
      }

      // Two ticks, not one: the card list is React's, and it only re-renders
      // with the new category after this tick's click has been processed.
      if (!state.cat) {
        var cats = pop.querySelectorAll(".sbdc-cat");
        if (cats.length > e.cat) cats[e.cat].click();
        state.cat = true;
        since = ticks;
        return;
      }

      var card = cardFor(pop, e);
      if (!card) {
        // ~2.5s of looking is plenty once the category is open. Beyond that the
        // popup does not sell this handle - go with what the category selected.
        if (ticks - since > 20) {
          state.gaveUp = "not-offered:" + HANDLE;
          state.picked = true;
        }
        return;
      }
      card.click();
      state.picked = true;
      since = ticks;
      return;
    }

    if (since && ticks - since < 3) return;            // let the panel settle

    // Size from the handle, once the product card has re-rendered the panel.
    if (!state.sized && state.size && resolved) {
      state.sized = true;
      if (applySize(pop, resolved)) { since = ticks; return; }
    }

    var go = pop.querySelector(".sbdc-go");
    if (!go) return;
    go.click();
    state.started = true;
    setTimeout(uncover, 150);                          // popup is closing
    clearInterval(timer);
  }, 120);

  addEventListener("pagehide", function () { clearInterval(timer); });
})();
